import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-attribute-viewer',
    templateUrl: './attribute-viewer.component.html',
    styleUrls: ['./attribute-viewer.component.scss']
})
export class AttributeViewerComponent {
    @Input() title: string | number | null | undefined;
    @Input() subTitle: string | null | undefined;
    @Input() label: string | null | undefined;
    @Input() icon: string | null = null;
    @Input() invert = true;
}
